import { BooleanInput } from '@angular/cdk/coercion';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
    forwardRef,
    inject,
    viewChild,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseHorizontalNavigationBasicItemComponent } from '@fuse/components/navigation/horizontal/components/basic/basic.component';
import { FuseHorizontalNavigationDividerItemComponent } from '@fuse/components/navigation/horizontal/components/divider/divider.component';
import { FuseHorizontalNavigationComponent } from '@fuse/components/navigation/horizontal/horizontal.component';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseNavigationItem } from '@fuse/components/navigation/navigation.types';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'fuse-horizontal-navigation-branch-item',
    templateUrl: './branch.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgClass,
        MatMenuModule,
        NgTemplateOutlet,
        FuseHorizontalNavigationBasicItemComponent,
        forwardRef(() => FuseHorizontalNavigationBranchItemComponent),
        FuseHorizontalNavigationDividerItemComponent,
        MatTooltipModule,
        MatIconModule,
    ],
})
export class FuseHorizontalNavigationBranchItemComponent
    implements OnInit, OnDestroy
{
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_child: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    private _changeDetectorRef = inject(ChangeDetectorRef);
    private _fuseNavigationService = inject(FuseNavigationService);
    menuClass = 'custom-parent-menu';

    isCustom = false;
    @Input() child: boolean = false;
    @Input() item: FuseNavigationItem;
    @Input() name: string;
    @Input() absolutePos : boolean = false;
    @ViewChild('matMenu', { static: true }) matMenu: MatMenu;
    showSubMenu: boolean =false;

    private _fuseHorizontalNavigationComponent: FuseHorizontalNavigationComponent;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    /**
     * On init
     */
    ngOnInit(): void {
        // Get the parent navigation component
        if(this.child === true){
            this.menuClass = 'custom-child-menu'
        }
        this._fuseHorizontalNavigationComponent =
            this._fuseNavigationService.getComponent(this.name);

        // Subscribe to onRefreshed on the navigation component
        this._fuseHorizontalNavigationComponent.onRefreshed
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Trigger the change detection
     */
    triggerChangeDetection(): void {
        // Mark for check
        this._changeDetectorRef.markForCheck();
    }

    /**
     * Track by function for @for loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    showMenu(){
        this.showSubMenu = !this.showSubMenu;
    }

    @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;
    private openTimeout: any;
    private closeTimeout: any;
    private lastOpenedTrigger: MatMenuTrigger | null = null;

    openMenuWithDelay(trigger : MatMenuTrigger) {
      clearTimeout(this.closeTimeout);
      this.openTimeout = setTimeout(() => {
        if (this.lastOpenedTrigger && this.lastOpenedTrigger !== trigger) {
          this.lastOpenedTrigger.closeMenu();
        }
        trigger.openMenu();
        this.lastOpenedTrigger = trigger;
      }, 150);
    }
  
    closeMenuWithDelay(trigger : MatMenuTrigger) {
      clearTimeout(this.openTimeout);
      this.closeTimeout = setTimeout(() => {
        if (this.lastOpenedTrigger != trigger) {
        trigger.closeMenu();
    }
        if (this.lastOpenedTrigger === trigger) {
          this.lastOpenedTrigger = null;
        }
      }, 300);
    }
  
    cancelCloseMenu() {
      clearTimeout(this.closeTimeout);
    }

}
